import styled from 'astroturf/react'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HtmlParser } from '@calendly/html-parser'
import { RoutingForm } from '@calendly/routing-form-landing'
import { useQueryParams } from '@calendly/hooks'

import ErrorAlert from 'components/error/alert'
import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'
import { countryCodeSelector } from 'selectors'
import { useRoutingForm } from 'components/use_routing_form'
import { useSendSegmentEvent } from 'hooks/use-segment-events'

import { CenteredLoader } from './loader'
import { createSubmission, getThankYouMessageFromRoute, isAutofillValidSelector, thankYouMessageSelector, validateAutofill } from './slice'
import _Container from "form_page-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/routing_form/form_page.js?styleId=Container";
import _Headline from "form_page-Headline.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/routing_form/form_page.js?styleId=Headline";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const Headline = /*#__PURE__*/styled('h2', null, {
  displayName: "Headline",
  styles: _Headline
})

const ThankYouPage = ({ body, headline }) => (
  <Container>
    <Headline>{headline}</Headline>
    {body && <div>{HtmlParser(body)}</div>}
  </Container>
)

const RoutingFormDetails = ({ form }) => {
  const thankYouMessage = useSelector(thankYouMessageSelector)
  const dispatch = useDispatch()
  const { route_id: routeId, ...params } = useQueryParams()
  const countryCode = useSelector(countryCodeSelector)
  const isAutofillValid = useSelector(isAutofillValidSelector)
  const config = useMemo(() => ({
    countryCode
  }), [countryCode])
  const sendSegmentEvent = useSendSegmentEvent()

  const { uuid: formId } = form

  useEffect(() => {
    sendSegmentEvent(
      'routing_form',
      { id: form.organization.owner.id, uuid: form.organization.owner.uuid },
      form.id,
      'routing_form_step'
    )
  }, [form, sendSegmentEvent])

  useEffect(() => {
    GoogleAnalytics.userTrackEvent('invitee_visits_routing_form', form.name)
    FbPixel.trackCustom('invitee_visits_routing_form', form.name)
  }, [form])

  useEffect(() => {
    if (routeId) {
      dispatch(getThankYouMessageFromRoute(routeId))
    }
  }, [dispatch, routeId])

  if (thankYouMessage) {
    const { body, headline } = thankYouMessage

    return <ThankYouPage body={body} headline={headline} />
  }

  if (routeId) {
    return null
  }

  const handleSubmit = async (values, options) => (
    dispatch(createSubmission({ formId, formName: form.name, submission: values, params, options }))
  )
  const handleAutofillValidation = (validate) => dispatch(validateAutofill(validate))

  return (
    <RoutingForm
      form={form}
      onSubmit={handleSubmit}
      onAutofillValidation={handleAutofillValidation}
      isAutofillValid={isAutofillValid}
      config={config}
    />
  )
}

export const RoutingFormPage = () => {
  const routingForm = useRoutingForm()

  if (routingForm === undefined) {
    return <CenteredLoader />
  }

  if (routingForm === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const form = {
    logo_url: routingForm.organization.logo_url,
    ...routingForm
  }

  return <RoutingFormDetails form={form} />
}
